import {enter, enterFrom, enterTo, leave, leaveFrom, leaveTo} from './transition.css';

export const fadeProps = () => {
  return {
    enter,
    enterFrom,
    enterTo,
    leave,
    leaveFrom,
    leaveTo,
  };
};
